class ArticlesInventoryAPI {
    checkStatus(response) {
        switch (response.status) {
            case 500:
                throw new Error(`${response.status} - Server Error!`);
            case 403:
                throw new Error(`${response.status} - Unhautorized!`);
            default:
                console.log("Success Response");
                break;
        }
    }

    async crearArticuloInventario(params) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}inventario/create`;
        await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify(params)
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                return response.json();
            }
            else
            {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async listarArticulosInventario() {
        let datos = [];
        let url = `${process.env.REACT_APP_PUBLIC_URL}inventario/listar`;
        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                return response.json();
            }
            else
            {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = [];
        });
        return datos;
    }

    async actualizarArticulosInventario (params) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}inventario/update`;
        await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify(params)
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                return response.json();
            }
            else
            {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

    async eliminarArticulosInventario (params) {
        let datos;
        let url = `${process.env.REACT_APP_PUBLIC_URL}inventario/delete`;
        await fetch(url, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify(params)
        }).then(response => {
            if(response.status != 500 && response.status != 403)
            {
                return response.json();
            }
            else
            {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(data => {
            datos = data;
        }).catch((error) => {
            datos = null;
        });
        return datos;
    }

}

export default new ArticlesInventoryAPI();